export const venue_columns = [
  {
    key: 'name',
    search_key: 'venues.name',
    sortKey: 'venues.name',
    label: 'Name',
    type: "text",
    sortable: true
  },
  {
    key: 'address',
    label: 'Address',
    type: "text",
    sortable: true,
  },
];
